import { CellContext, Selected, SelectElement } from '@optimus-web/core';
import { listOptions } from '../sections';
import { isCheckInConfigurationValue } from '../utils';
import { DocumentsTableDataItem } from './types';

export const VisibilityAction = (props: CellContext<DocumentsTableDataItem, unknown>) => {
    const current = props.row.original;
    const { isVisibilityDisabled, setDocumentsVisibilityData, visibility, tooltip, fieldName } = current;

    const handleActionClick = (_e: React.ChangeEvent, value: Selected) => {
        if (isCheckInConfigurationValue(value)) {
            setDocumentsVisibilityData(value);
        }
    };

    return (
        <SelectElement
            onChange={handleActionClick}
            searchValueMapper={(component) => component.props.searchValue ?? ''}
            selected={visibility.reservationOwner}
            disabled={isVisibilityDisabled}
            name="guestCheckInFieldConfigurationDocumentsTable"
            sizeToAnchor={false}
        >
            {listOptions({ defaultTooltipValue: tooltip, fieldName, isDisabled: false })}
        </SelectElement>
    );
};
